import getLiveAgentIdByLanguageId from '~/utils/config/getLiveAgentIdByLanguageId'
import { useLanguageStore } from '~/store/language'

export default defineNuxtPlugin((_nuxtApp) => {
  const languageId = useLanguageStore().getLanguageId

  const liveAgentId = getLiveAgentIdByLanguageId(languageId)

  if (liveAgentId && typeof window !== 'undefined') {
    /* @ts-ignore */
    ;(function (doc, src, callback) {
      const totalScripts = doc.scripts[doc.scripts.length - 1]
      const script = doc.createElement('script')
      script.id = 'la_x2s6df8d'
      script.async = true
      script.src = src
      /* @ts-ignore */
      script.onload = script.onreadystatechange = function () {
        /* @ts-ignore */
        const rs = this.readyState
        if (rs && rs !== 'complete' && rs !== 'loaded') {
          return
        }
        // eslint-disable-next-line n/no-callback-literal
        callback(this)
      }
      // @ts-ignore
      totalScripts.parentElement.insertBefore(script, totalScripts.nextSibling)
    })(document, 'https://shipzee.ladesk.com/scripts/track.js', function (e: any) {
      ;(window as any).LiveAgent.createButton(liveAgentId, e)
    })
  }
})
